// extracted by mini-css-extract-plugin
export default {"changeEmailModaLWrapper":"ChangeEmail_changeEmailModaLWrapper__zWJBa"};